/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_WonInputs */

const cs_deals_won = /** @type {(inputs: Deals_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhráno`)
};

const en_deals_won = /** @type {(inputs: Deals_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Won`)
};

/**
* | output |
* | --- |
* | "Won" |
*
* @param {Deals_WonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_won = /** @type {((inputs?: Deals_WonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_WonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_won(inputs)
	return cs_deals_won(inputs)
});